import React, { useEffect, useState } from "react";
import { getShare } from "../api";
import ResultsPanel from "./ResultsPanel";
import Markdown from "./Markdown";

const ORANGE = "#c4622d";

function MessageBubble({ msg }) {
  const [sqlOpen, setSqlOpen] = useState(false);

  if (msg.role === "user") {
    return (
      <div style={styles.userBubble}>
        <span>{msg.content}</span>
      </div>
    );
  }

  if (msg.error) {
    return (
      <div style={styles.errorBubble}>
        <strong>Error:</strong> {msg.content}
      </div>
    );
  }

  return (
    <div style={styles.assistantBubble}>
      <Markdown>{msg.content}</Markdown>
      {msg.sql && (
        <div>
          <button style={styles.sqlToggle} onClick={() => setSqlOpen(!sqlOpen)}>
            {sqlOpen ? "▾ hide SQL" : "▸ show SQL"}
          </button>
          {sqlOpen && <pre style={styles.sqlBlock}>{msg.sql}</pre>}
        </div>
      )}
    </div>
  );
}

export default function SharedView({ shareId }) {
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    getShare(shareId).then((d) => {
      if (!d) setNotFound(true);
      else setData(d);
    });
  }, [shareId]);

  const messages = data?.messages?.filter((m) => !m.isWelcome) ?? [];
  const result = data?.result ?? null;

  return (
    <div className="app-shell">
      <header className="app-header">
        <a href="/" style={styles.logo}>NYRR Head to Head</a>
        <span style={styles.badge}>Shared conversation</span>
        <a href="/" style={styles.cta}>Try it yourself →</a>
      </header>

      {notFound ? (
        <div style={styles.empty}>Conversation not found.</div>
      ) : !data ? (
        <div style={styles.empty}>Loading…</div>
      ) : (
        <div className="app-body">
          <div className="chat-col">
            <div style={styles.messagesPanel}>
              <div style={styles.messagesHeader}>
                <h2 style={styles.messagesTitle}>Conversation</h2>
              </div>
              <div style={styles.messages}>
                {messages.map((msg, i) => (
                  <MessageBubble key={i} msg={msg} />
                ))}
              </div>
            </div>
          </div>
          <div className="results-col">
            <ResultsPanel result={result} />
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  logo: {
    fontWeight: 700,
    fontSize: "1.1rem",
    color: ORANGE,
    textDecoration: "none",
  },
  badge: {
    fontSize: "0.78rem",
    color: "#888",
    background: "#f0f0f0",
    padding: "3px 10px",
    borderRadius: "10px",
  },
  cta: {
    marginLeft: "auto",
    fontSize: "0.85rem",
    color: ORANGE,
    textDecoration: "none",
    fontWeight: 500,
  },
  empty: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#aaa",
    fontSize: "0.9rem",
  },
  messagesPanel: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    borderRight: "1px solid #e1e1e1",
  },
  messagesHeader: {
    padding: "16px 20px 12px",
    borderBottom: "1px solid #e1e1e1",
    background: "#fff",
  },
  messagesTitle: {
    margin: 0,
    fontSize: "1.1rem",
    fontWeight: 600,
    color: ORANGE,
  },
  messages: {
    flex: 1,
    overflowY: "auto",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  userBubble: {
    alignSelf: "flex-end",
    background: ORANGE,
    color: "#fff",
    borderRadius: "18px 18px 4px 18px",
    padding: "10px 14px",
    maxWidth: "80%",
    fontSize: "0.9rem",
  },
  assistantBubble: {
    alignSelf: "flex-start",
    background: "#f4f5f6",
    borderRadius: "18px 18px 18px 4px",
    padding: "10px 14px",
    maxWidth: "90%",
    fontSize: "0.9rem",
    color: "#333",
  },
  errorBubble: {
    alignSelf: "flex-start",
    background: "#fff0f0",
    border: "1px solid #ffcccc",
    borderRadius: "8px",
    padding: "10px 14px",
    maxWidth: "90%",
    fontSize: "0.85rem",
    color: "#c00",
  },
  sqlToggle: {
    background: "none",
    border: "none",
    color: ORANGE,
    cursor: "pointer",
    fontSize: "0.8rem",
    padding: 0,
  },
  sqlBlock: {
    marginTop: "6px",
    padding: "8px",
    background: "#1e1e1e",
    color: "#d4d4d4",
    borderRadius: "4px",
    fontSize: "0.75rem",
    overflowX: "auto",
    whiteSpace: "pre-wrap",
    wordBreak: "break-all",
  },
};
